import SingleBanner from './SingleBannerContainer';

export default SingleBanner;
